import { useQuery } from "@tanstack/react-query";
import { reactQueryOptions } from "src/config/reactQuery.config";
import {
  getSalespersonActiveCustomers,
  getSalespersonList,
  getSalespersonListDetail,
  getSalespersonTransactionList,
} from "src/services/SalespersonList.service";
import {
  SalespersonActiveCustomersRequestBody,
  SalespersonListDetailRequestBody,
  SalespersonListParams,
  SalespersonTransactionListRequestBody,
} from "./interfaces";
import { useGetAccessPermission } from "src/hooks/useGetAccessPermission";
import { AccessResource, ActionType } from "src/types/accessControl";

const key = "salesperson";
export const listKey = `${key}-list`;
export const detailKey = `${key}-detail`;
export const activeCustomerKey = `${key}-active_customer`;
export const transactionListKey = `${key}-transaction_list`;

export const useGetSalespersonList = (params: SalespersonListParams) => {
  const isAllowedSalespersonList = useGetAccessPermission({
    resource: AccessResource["User Management - Salesperson List"],
    action: ActionType["Read"],
  });

  return useQuery({
    ...reactQueryOptions,
    queryKey: [listKey, params],
    queryFn: () => getSalespersonList(params),
    enabled: isAllowedSalespersonList,
  });
};

export const useGetSalespersonListDetail = (
  requestBody: SalespersonListDetailRequestBody
) => {
  return useQuery({
    ...reactQueryOptions,
    queryKey: [detailKey, requestBody],
    queryFn: () => getSalespersonListDetail(requestBody),
  });
};

export const useGetSalespersonActiveCustomers = (
  requestBody: SalespersonActiveCustomersRequestBody
) => {
  return useQuery({
    ...reactQueryOptions,
    queryKey: [activeCustomerKey, requestBody],
    queryFn: () => getSalespersonActiveCustomers(requestBody),
  });
};

export const useGetSalespersonTransactionList = (
  requestBody: SalespersonTransactionListRequestBody
) => {
  return useQuery({
    ...reactQueryOptions,
    queryKey: [transactionListKey, requestBody],
    queryFn: () => getSalespersonTransactionList(requestBody),
  });
};
